import React, { Component } from 'react';
import { messageAction, globalAction } from '../../../../store/action';
import { localStore } from '../../../../helpers';
import { globalStateSelector } from '../../../../store/selector';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
global.__btnTimer = "";
export class EventManager extends Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    // console.log(`componentWillReceiveProps EventManager`, this.props.isConnected, '==', nextProps.isConnected);  // Outputs ['a','b','c'] == ['a','b','c']
    if (this.props.isConnected != nextProps.isConnected) {
      const { configProcessor } = this.props;
      configProcessor(`liveMonitor`);
      // configProcessor(`liveSubscriber`);
      configProcessor(`previewCont`);
      configProcessor(`recentCalls`);
      configProcessor(`pauseList`);
      configProcessor(`teamList`);
    }
  }
  componentWillUnmount() {
    // window.removeEventListener('scroll', this.onScroll, false);
  }
  getOrganisationUrl() {
    // eslint-disable-next-line react/prop-types
    const {
      receiveSocketMessage,
      sipDomain,
      accessUrl,
      socketUrl,
      sipUrl,
      currentUser,
      dynamicUpdate
    } = this.props;
    //  sent server url
    if (socketUrl) {
      let sipConfig = null;
      if (sipUrl && currentUser && currentUser.sip) {
        sipConfig = {
          url: sipUrl,
          username: currentUser.sip.userName,
          password: currentUser.sip.password,
          domain: sipDomain
        };
      }
      dynamicUpdate({ key: 'sipConfig', value: sipConfig });
      receiveSocketMessage({
        url: socketUrl,
        query: {
          token: localStore.getItem('token'),
          tenantId: localStore.getItem('selected-tenant')
        },
        sipConfig: sipConfig
      });
    }
  }
  componentDidMount() {
    // const { configProcessor } = this.props;
    this.getOrganisationUrl();
    // configProcessor(`pauseList`);
    // configProcessor(`recentCalls`);
    // configProcessor(`teamList`);
    // setTimeout(() => {
    //   this.sendMessage({
    //     type: 'tenant-app',
    //     tenant: 'getCallList'
    //   });
    // }, 500);
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  render() {
    // console.log
    // eslint-disable-next-line react/prop-types
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

const stateToProps = state => ({
  isConnected: globalStateSelector.getIsConnected(state),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  accessUrl: globalStateSelector.getDynamic(state, { key: 'accessUrl' }),
  socketUrl: globalStateSelector.getDynamic(state, { key: 'socketUrl' }),
  sipUrl: globalStateSelector.getDynamic(state, { key: 'sipUrl' }),
  sipDomain: globalStateSelector.getDynamic(state, { key: 'sipDomain' })
});

const dispatchToProps = dispatch => ({
  receiveSocketMessage: config => {
    dispatch(messageAction.receiveSocketMessage(config));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default connect(stateToProps, dispatchToProps)(EventManager);



// WEBPACK FOOTER //
// src/dialpad/components/layout/transport/EventManager.js